var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.62891V9.62891H20V7.62891C20 7.09847 19.7893 6.58977 19.4142 6.21469C19.0391 5.83962 18.5304 5.62891 18 5.62891H6C5.46957 5.62891 4.96086 5.83962 4.58579 6.21469C4.21071 6.58977 4 7.09847 4 7.62891Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.62891H18C18.5304 5.62891 19.0391 5.83962 19.4142 6.21469C19.7893 6.58977 20 7.09847 20 7.62891V9.62891H4V7.62891C4 7.09847 4.21071 6.58977 4.58579 6.21469C4.96086 5.83962 5.46957 5.62891 6 5.62891H8M16 5.62891V3.62891M16 5.62891H8M8 5.62891V3.62891M4 10.1289V19.6289C4 20.1593 4.21071 20.668 4.58579 21.0431C4.96086 21.4182 5.46957 21.6289 6 21.6289H18C18.5304 21.6289 19.0391 21.4182 19.4142 21.0431C19.7893 20.668 20 20.1593 20 19.6289V10.1289",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendaricon);
export default __webpack_public_path__ + "static/media/calendaricon.7d09890f6f7c5f1c10cc327651d3e5a7.svg";
export { ForwardRef as ReactComponent };